/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { WalletBalanceResponse } from '../../models/wallet-balance-response';

export interface BookingControllerGetWalletBalanceGmg$Params {
}

export function bookingControllerGetWalletBalanceGmg(http: HttpClient, rootUrl: string, params?: BookingControllerGetWalletBalanceGmg$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: WalletBalanceResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerGetWalletBalanceGmg.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: WalletBalanceResponse;
      }>;
    })
  );
}

bookingControllerGetWalletBalanceGmg.PATH = '/booking/wallet/balance-gmg';
